import { Component, OnInit } from '@angular/core';
import { PlansDTO, SignatureService, SubscriptionDTO } from 'src/app/services/signature.service';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-signature',
  templateUrl: './signature.component.html',
  styleUrls: ['./signature.component.scss'],
})
export class SignatureComponent implements OnInit {
  constructor(
    private signatureService: SignatureService,
    private loginService: LoginService,
  ) { }

  loading = true;
  signature: SubscriptionDTO | null = null;
  subscriptionEndDayString = '';
  subscriptionStatus = '';
  canRenew = false;
  renewUrl = '';
  salesUrl = '';
  showRefresh = false;


  offerPlans: PlansDTO[] = [];

  ngOnInit(): void {
    this.loadData();
  }

  onRefresh() {
    this.loadData();
  }

  private loadData() {
    this.loading = true;
    this.showRefresh = false;


    this.signatureService.ensureUserSubscriptionV2().subscribe({
      next: () => { },
      error: (err) => {
        const msg = err?.error?.message || err?.message || 'Não foi possível sincronizar assinatura.';
        this.loginService.showMessage(msg, 6000);
        this.showRefresh = true;

        this.signatureService.getUserSubscriptionV2().subscribe({
          next: data => {
            this.signature = data ?? null;
            this.subscriptionEndDayString = this.signature
              ? this.remainingDaysCount(this.signature.finishedAt)
              : '';

            this.signatureService.getActionLinksV2().subscribe({
              next: links => {
                const notFound = links?.status === 'plano não encontrado';
                this.renewUrl = notFound ? '' : (links?.renewUrl || '');
                this.salesUrl = links?.salesUrl || '';
                this.canRenew = !notFound && !!links?.canRenew;
                this.subscriptionStatus = notFound ? '' : this.mapStatus(links?.status || '');
                this.showRefresh = notFound;

                if (notFound) {
                  this.signature = null;
                  this.signatureService.getOfferPlansV2().subscribe({
                    next: plans => {
                      this.offerPlans = (plans || []).map(p => ({
                        ...p,
                        isSupportPriorityString: p.isSupportPriority ? 'Prioritário' : 'Normal',
                        indicationLimitString: !p.indicationLimit ? 'Ilimitado' : String(p.indicationLimit),
                      }));
                      this.loading = false;
                    },
                    error: () => {
                      this.offerPlans = [];
                      this.loading = false;
                    }
                  });
                } else {
                  this.loading = false;
                }
              },
              error: () => {
                this.canRenew = false;
                this.subscriptionStatus = '';
                this.showRefresh = true;
                this.loading = false;
              }
            });
          },
          error: () => {
            this.loginService.showMessage('Erro ao carregar informações de assinatura');
            this.showRefresh = true;
            this.loading = false;
          }
        });
      },
      complete: () => {
        this.signatureService.getUserSubscriptionV2().subscribe({
          next: data => {
            this.signature = data ?? null;
            this.subscriptionEndDayString = this.signature
              ? this.remainingDaysCount(this.signature.finishedAt)
              : '';

            this.signatureService.getActionLinksV2().subscribe({
              next: links => {
                const notFound = links?.status === 'plano não encontrado';
                this.renewUrl = notFound ? '' : (links?.renewUrl || '');
                this.salesUrl = links?.salesUrl || '';
                this.canRenew = !notFound && !!links?.canRenew;
                this.subscriptionStatus = notFound ? '' : this.mapStatus(links?.status || '');

                if (notFound) {
                  this.signature = null;
                  this.signatureService.getOfferPlansV2().subscribe({
                    next: plans => {
                      this.offerPlans = (plans || []).map(p => ({
                        ...p,
                        isSupportPriorityString: p.isSupportPriority ? 'Prioritário' : 'Normal',
                        indicationLimitString: !p.indicationLimit ? 'Ilimitado' : String(p.indicationLimit),
                      }));
                      this.loading = false;
                    },
                    error: () => {
                      this.offerPlans = [];
                      this.loading = false;
                    }
                  });
                } else {
                  this.loading = false;
                }
              },
              error: () => {
                this.canRenew = false;
                this.subscriptionStatus = '';
                this.loading = false;
              }
            });
          },
          error: () => {
            this.loginService.showMessage('Erro ao carregar informações de assinatura');
            this.loading = false;
          }
        });
      }
    });
  }

  openRenew() {
    if (!this.canRenew || !this.renewUrl) {
      this.loginService.showMessage('Renovação indisponível no momento');
      return;
    }
    const w = window.open('', '_blank');
    if (w) {
      w.opener = null;
      w.location.href = this.renewUrl;
    } else {
      window.open(this.renewUrl, '_blank');
    }
  }

  openSales() {
    const url = this.salesUrl || 'https://wa.me/556791187271';
    window.open(url, '_blank');
  }

  goToPlan(planUrl: string) {
    if (!planUrl) {
      this.loginService.showMessage('Plano indisponível no momento');
      return;
    }
    const w = window.open('', '_blank');
    if (w) {
      w.opener = null;
      w.location.href = planUrl;
    } else {
      window.open(planUrl, '_blank');
    }
  }

  private remainingDaysCount(finishedAt: string): string {
    const today = new Date();
    const finishDate = new Date(`${finishedAt}T23:59:59`);
    const diff = finishDate.getTime() - today.getTime();
    const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
    if (days <= 0) return 'Encerrado.';
    return `${days} ${days === 1 ? 'dia.' : 'dias.'}`;
  }

  private mapStatus(status: string): string {
    const s = (status || '').trim();
    if (!s) return '';
    if (s.toLowerCase() === 'expirado' || s === 'Expirada') return 'Vencida';
    return s.charAt(0).toUpperCase() + s.slice(1);
  }
}
